import { Amplify } from "aws-amplify";
import { get, put } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

const authConfig = {
  Cognito: {
    userPoolId: "us-west-1_MRRH7QyfO",
    userPoolClientId: "5qt0r318huub5gh0186csj59ui",
  },
};

Amplify.configure({
  Auth: authConfig,
  API: {
    REST: {
      igniteinsights: {
        endpoint: "https://j5dk657cyb.execute-api.us-west-1.amazonaws.com/dev",
        region: "us-west-1",
      },
    },
  },
});

export async function getTeams(
  itemCount = 100,
  offset = 0,
  show_icons = false,
  searchText = ""
) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/teams?itemCount=${itemCount}&offset=${offset}&show_icons=${show_icons}&searchText=${searchText}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function getSpecificTeam(team = 0) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/teams?team_number=${team}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function getTeamsByEvent(event) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const response = await fetch(
      `https://www.thebluealliance.com/api/v3/event/${event}/teams`,
      {
        headers: {
          "X-TBA-Auth-Key":
            "awpaQWQYzO8lbvawU991yecembSfJzVj9lFK01yxZvVaYJTD6yTnsgl4mhlXXy1E",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch teams");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error Getting Teams By Match:", error);
    throw error;
  }
}

export async function setIcons({ team }) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const response = await fetch(
      `https://www.thebluealliance.com/api/v3/team/frc${team.team_number}/media/2025`,
      {
        headers: {
          "X-TBA-Auth-Key":
            "awpaQWQYzO8lbvawU991yecembSfJzVj9lFK01yxZvVaYJTD6yTnsgl4mhlXXy1E",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch media");
    }

    const data = await response.json();
    const base64Image = data[0]?.details?.base64Image;
    console.log(base64Image);

    const restOperation = put({
      apiName: "igniteinsights",
      path: `/teams`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          ...team,
          icon_picture: base64Image,
        },
      },
    });

    const finalResponse = await restOperation.response;
    return finalResponse;
  } catch (error) {
    console.error("Error fetching or updating icons:", error);
    throw error;
  }
}
